import { useContext, useState } from 'react'
import { ThemeContext } from '../../contexts/theme'
import './Experience.css';
import { experience } from '../../portfolio'

const Experience = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);

  return (
   <section id='experience' className="experience-container">
  <h2 className='section__title'>💼 Work Experience</h2>
  <div className=''>
  {experience.map((item) => (
    <div className='role experience-content'>
      <div className='role-header'>
         <img
                src={item.logo}
                alt={item.company}
                className='company-logo'
              />
        <h4 className='role-title'>{item.designation} -  <span className='company'>{item.company}</span></h4>
        <div className='role-meta'>
          <span className='role-dates'>{item.dates}</span>
        </div>
      </div>
      <ul className='role-details'>
        {item.description.map((point, idx) => (
          <li  dangerouslySetInnerHTML={{ __html: point }} />
        ))}
      </ul>
    </div>
  ))}
</div>


</section>

  )
}

export default Experience
